import React from "react";

import { OutProductDTO } from "@app/bf-api";
import { SimpleProductCard } from "@app/components/product-cards/simple-product-card/simple-product-card";
import { ClickableComponent } from "@app/core/clickable";
import IconChevronRight from "@assets/icons/chevron-right-sharp.svg";
import { formatMessage } from "@app/translations/intl";

import styles from "../search-results.module.scss";

interface IProps {
  headerText: string;
  products: OutProductDTO[];
  count?: number;
  closeSearch: () => void;
}

const component = ({ headerText, products, count, closeSearch }: IProps) => {
  return (
    <div className={styles.searchResultContainer}>
      <div className={styles.header}>
        {headerText} {(count || 0) > 0 ? `(${count})` : ""}
      </div>

      <div className={styles.body}>
        <div className={styles.pagePanel}>
          {products?.map((product, index) => (
            <div key={index}>
              <SimpleProductCard product={product} anchorProps={{ onClick: closeSearch }} />
            </div>
          ))}
        </div>
        <div onClick={closeSearch} className={styles.link}>
          <ClickableComponent
            title={formatMessage({ id: "navbar.search.result.button.products" })}
            iconStyle="filled"
            iconRight={IconChevronRight}
            iconFillColor="white"
            iconSize="14px"
            variant="primary-2025-brand"
            href={formatMessage({ id: "global.productOverviewLink" })}
          />
        </div>
      </div>
    </div>
  );
};

export const NavBarResultProducts = component;
